module.exports = __webpack_public_path__ + "static/media/live14_02_2024.f16329d7.jpg";